import { useState, useEffect, useMemo } from "react";
import { getEntrevistaById, getPacienteInformeById } from "../api/entrevistaApi";
import {
  ACTIVIDADES_LIST,
  SECTION_IDS,
  VIVEN_LABELS,
  GRUPO_LABELS,
  EDUCACION_LABELS,
  SEXO_LABELS,
  FUMADOR_LABELS,
  ALCOHOL_LABELS,
} from "../model/entrevistaConstants";
import { formatBirthDate, formatDate, parseDate } from "../utils/entrevistaDate";

export {
  ACTIVIDADES_LIST,
  SECTION_IDS,
  VIVEN_LABELS,
  GRUPO_LABELS,
  EDUCACION_LABELS,
  SEXO_LABELS,
  FUMADOR_LABELS,
  ALCOHOL_LABELS,
  formatDate,
  parseDate,
};

const createActividadesState = (selected = []) =>
  ACTIVIDADES_LIST.reduce((acc, a) => {
    acc[a] = selected.includes(a);
    return acc;
  }, {});

export function useEntrevistaData(idEntrevista, paciente) {
  const [loadError, setLoadError] = useState(false);

  // Paciente
  const [codigo, setCodigo] = useState("");
  const [createdAt, setCreatedAt] = useState("");
  const [nombre, setNombre] = useState("");
  const [apellidos, setApellidos] = useState("");
  const [telefono, setTelefono] = useState("");
  const [dateBirth, setDateBirth] = useState("");
  const [numViven, setNumViven] = useState("");
  const [numGrupo, setNumGrupo] = useState("");
  const [numNivelEducacional, setNumNivelEducacional] = useState("");
  const [numSexo, setNumSexo] = useState("");

  // Entrevista
  const [codigoEntrevista, setCodigoEntrevista] = useState("");
  const [tipoEntrevista, setTipoEntrevista] = useState("");
  const [edad, setEdad] = useState(0);
  const [numFumador, setNumFumador] = useState(0);
  const [tiempoFumador, setTiempoFumador] = useState("");
  const [aniosDeshabilitacion, setAniosDeshabilitacion] = useState("");
  const [numAlcohol, setNumAlcohol] = useState(0);
  const [tiempoAlcohol, setTiempoAlcohol] = useState("");
  const [aniosDeshabilitacionAlcohol, setAniosDeshabilitacionAlcohol] = useState("");
  const [caidas12Meses, setCaidas12Meses] = useState(false);
  const [numCaidas, setNumCaidas] = useState("");
  const [ayudaLocomocion, setAyudaLocomocion] = useState(false);

  // Sistemas
  const [protesisArticulares, setProtesisArticulares] = useState(false);
  const [protesisRodilla, setProtesisRodilla] = useState(false);
  const [protesisCadera, setProtesisCadera] = useState(false);
  const [protesisHombro, setProtesisHombro] = useState(false);
  const [protesisManoDedos, setProtesisManoDedos] = useState(false);
  const [protesisOtros, setProtesisOtros] = useState("");
  const [vertigos, setVertigos] = useState(false);
  const [mareosAndar, setMareosAndar] = useState(false);
  const [cardiovascular, setCardiovascular] = useState(false);
  const [hipertension, setHipertension] = useState(false);
  const [insuficienciaCardiaca, setInsuficienciaCardiaca] = useState(false);
  const [accCerebrovascular, setAccCerebrovascular] = useState(false);
  const [anginaPecho, setAnginaPecho] = useState(false);
  const [infarto, setInfarto] = useState(false);
  const [trombosis, setTrombosis] = useState(false);
  const [otrosCardiovascular, setOtrosCardiovascular] = useState("");
  const [respiratorio, setRespiratorio] = useState(false);
  const [asma, setAsma] = useState(false);
  const [epoc, setEpoc] = useState(false);
  const [otrosRespiratorio, setOtrosRespiratorio] = useState("");
  const [genitoUrinario, setGenitoUrinario] = useState(false);
  const [infeccionUrinaria, setInfeccionUrinaria] = useState(false);
  const [calculosRenales, setCalculosRenales] = useState(false);
  const [insuficienciaRenal, setInsuficienciaRenal] = useState(false);
  const [incontinenciaUrinaria, setIncontinenciaUrinaria] = useState(false);
  const [prostata, setProstata] = useState(false);
  const [otrosGenitoUrinario, setOtrosGenitoUrinario] = useState("");
  const [endocrino, setEndocrino] = useState(false);
  const [diabetes, setDiabetes] = useState(false);
  const [hipotiroidismo, setHipotiroidismo] = useState(false);
  const [hipercolesterolemia, setHipercolesterolemia] = useState(false);
  const [osteoporosis, setOsteoporosis] = useState(false);
  const [otrosEndocrino, setOtrosEndocrino] = useState("");
  const [digestivo, setDigestivo] = useState(false);
  const [herniaHiato, setHerniaHiato] = useState(false);
  const [reflujo, setReflujo] = useState(false);
  const [pancreatitis, setPancreatitis] = useState(false);
  const [enfermedadHepatica, setEnfermedadHepatica] = useState(false);
  const [diverticulitis, setDiverticulitis] = useState(false);
  const [otrosDigestivo, setOtrosDigestivo] = useState("");
  const [musculoEsqueletico, setMusculoEsqueletico] = useState(false);
  const [pieTobillo, setPieTobillo] = useState(false);
  const [rodilla, setRodilla] = useState(false);
  const [cadera, setCadera] = useState(false);
  const [lumbar, setLumbar] = useState(false);
  const [dorsal, setDorsal] = useState(false);
  const [cervical, setCervical] = useState(false);
  const [cabeza, setCabeza] = useState(false);
  const [hombro, setHombro] = useState(false);
  const [codo, setCodo] = useState(false);
  const [manoMunieca, setManoMunieca] = useState(false);
  const [nervioso, setNervioso] = useState(false);
  const [depresion, setDepresion] = useState(false);
  const [ansiedad, setAnsiedad] = useState(false);
  const [esclerosisMultiple, setEsclerosisMultiple] = useState(false);
  const [parkinson, setParkinson] = useState(false);
  const [alzheimer, setAlzheimer] = useState(false);
  const [deterioroCognitivo, setDeterioroCognitivo] = useState(false);
  const [neuropatiaPeriferica, setNeuropatiaPeriferica] = useState(false);
  const [otrosNervioso, setOtrosNervioso] = useState("");
  const [sentidos, setSentidos] = useState(false);
  const [hipoacusia, setHipoacusia] = useState(false);
  const [tinitus, setTinitus] = useState(false);
  const [perdidaVision, setPerdidaVision] = useState(false);

  // Medicación y seguimiento
  const [datosInteres, setDatosInteres] = useState("");
  const [numAnalgesicos, setNumAnalgesicos] = useState("");
  const [medicacion, setMedicacion] = useState(false);
  const [antihipertensivos, setAntihipertensivos] = useState(false);
  const [antidiabeticos, setAntidiabeticos] = useState(false);
  const [estatinas, setEstatinas] = useState(false);
  const [anticoagulantes, setAnticoagulantes] = useState(false);
  const [tiroides, setTiroides] = useState(false);
  const [diuretico, setDiuretico] = useState(false);
  const [analgesicos, setAnalgesicos] = useState(false);
  const [antidepresivos, setAntidepresivos] = useState(false);
  const [ansioliticos, setAnsioliticos] = useState(false);
  const [antiosteoporoticos, setAntiosteoporoticos] = useState(false);
  const [inhalador, setInhalador] = useState(false);
  const [protectorEstomago, setProtectorEstomago] = useState(false);
  const [otrosMedicacion, setOtrosMedicacion] = useState("");
  const [venredi, setVenredi] = useState(false);
  const [terapiaOcupacional, setTerapiaOcupacional] = useState(false);
  const [tensionPAS, setTensionPAS] = useState("");
  const [tensionPAD, setTensionPAD] = useState("");
  const [tensionPMM, setTensionPMM] = useState("");
  const [actividades, setActividades] = useState(() => createActividadesState());
  const [actividadesExtras, setActividadesExtras] = useState([]);

  // Entrevista final
  const [caidasFinales, setCaidasFinales] = useState("");
  const [numPastillas, setNumPastillas] = useState("");
  const [numAnalgesicosFinal, setNumAnalgesicosFinal] = useState("");
  const [cambioMedicacionFinal, setCambioMedicacionFinal] = useState(false);
  const [consultaMedico, setConsultaMedico] = useState(false);
  const [ingresosHospital, setIngresosHospital] = useState(false);
  const [datosInteresFinal, setDatosInteresFinal] = useState("");

  const actividadesSeleccionadas = useMemo(() => {
    const seleccionadas = ACTIVIDADES_LIST.filter((a) => actividades[a]);
    return actividadesExtras.length
      ? [...seleccionadas, ...actividadesExtras]
      : seleccionadas;
  }, [actividades, actividadesExtras]);

  useEffect(() => {
    if (!paciente || process.env.NODE_ENV === "test") return;

    getPacienteInformeById(paciente)
      .then((pd) => {
        setCodigo(pd.id);
        setNombre(pd.firstname);
        setApellidos(pd.lastname);
        setTelefono(pd.telefono);
        setDateBirth(formatBirthDate(pd.dateBirth));
        setNumViven(pd.viven);
        setNumGrupo(pd.grupo);
        setNumNivelEducacional(pd.nivelEducacional);
        setNumSexo(pd.sexo);
      })
      .catch((err) => { console.error(err); setLoadError(true); });

    getEntrevistaById(idEntrevista)
      .then((ed) => {
        setCodigoEntrevista(ed.codigo);
        setTipoEntrevista(ed.tipoEntrevista || "");
        setCreatedAt(formatDate(ed.createdAt));
        setEdad(ed.edad);
        setNumFumador(ed.fumador);
        setTiempoFumador(ed.tiempoFumador ?? "");
        setAniosDeshabilitacion(ed.aniosDeshabilitacion ?? "");
        setNumAlcohol(ed.alcohol);
        setTiempoAlcohol(ed.tiempoAlcohol ?? "");
        setAniosDeshabilitacionAlcohol(ed.aniosDeshabilitacionAlcohol ?? "");
        setCaidas12Meses(ed.caidas12Meses);
        setNumCaidas(ed.numCaidas ?? "");
        setAyudaLocomocion(ed.ayudaLocomocion);
        setProtesisArticulares(ed.protesisArticulares);
        setProtesisRodilla(ed.protesisRodilla);
        setProtesisCadera(ed.protesisCadera);
        setProtesisHombro(ed.protesisHombro);
        setProtesisManoDedos(ed.protesisManoDedos);
        setProtesisOtros(ed.protesisOtros);
        setVertigos(ed.vertigos);
        setMareosAndar(ed.mareosAndar);
        setCardiovascular(ed.cardiovascular);
        setHipertension(ed.hipertension);
        setInsuficienciaCardiaca(ed.insuficienciaCardiaca);
        setAccCerebrovascular(ed.accCerebrovascular);
        setAnginaPecho(ed.anginaPecho);
        setInfarto(ed.infarto);
        setTrombosis(ed.trombosis);
        setOtrosCardiovascular(ed.otrosCardiovascular);
        setRespiratorio(ed.respiratorio);
        setAsma(ed.asma);
        setEpoc(ed.epoc);
        setOtrosRespiratorio(ed.otrosRespiratorio ?? "");
        setGenitoUrinario(ed.genitoUrinario);
        setInfeccionUrinaria(ed.infeccionUrinaria);
        setCalculosRenales(ed.calculosRenales);
        setInsuficienciaRenal(ed.insuficienciaRenal);
        setIncontinenciaUrinaria(ed.incontinenciaUrinaria);
        setProstata(ed.prostata);
        setOtrosGenitoUrinario(ed.otrosGenitoUrinario);
        setEndocrino(ed.endocrino);
        setDiabetes(ed.diabetes);
        setHipotiroidismo(ed.hipotiroidismo);
        setHipercolesterolemia(ed.hipercolesterolemia);
        setOsteoporosis(ed.osteoporosis);
        setOtrosEndocrino(ed.otrosEndocrino);
        setDigestivo(ed.digestivo);
        setHerniaHiato(ed.herniaHiato);
        setReflujo(ed.reflujo);
        setPancreatitis(ed.pancreatitis);
        setEnfermedadHepatica(ed.enfermedadHepatica);
        setDiverticulitis(ed.diverticulitis);
        setOtrosDigestivo(ed.otrosDigestivo);
        setMusculoEsqueletico(ed.musculoEsqueletico);
        setPieTobillo(ed.pieTobillo);
        setRodilla(ed.rodilla);
        setCadera(ed.cadera);
        setLumbar(ed.lumbar);
        setDorsal(ed.dorsal);
        setCervical(ed.cervical);
        setCabeza(ed.cabeza);
        setHombro(ed.hombro);
        setCodo(ed.codo);
        setManoMunieca(ed.mano_munieca);
        setNervioso(ed.nervioso);
        setDepresion(ed.depresion);
        setAnsiedad(ed.ansiedad);
        setEsclerosisMultiple(ed.esclerosisMultiple);
        setParkinson(ed.parkinson);
        setAlzheimer(ed.alzheimer);
        setDeterioroCognitivo(ed.deterioroCognitivo);
        setNeuropatiaPeriferica(ed.neuropatiaPeriferica);
        setOtrosNervioso(ed.otrosNervioso);
        setSentidos(ed.sentidos);
        setHipoacusia(ed.hipoacusia);
        setTinitus(ed.tinitus);
        setPerdidaVision(ed.perdidaVision);
        setDatosInteres(ed.datosInteres);
        setNumAnalgesicos(ed.numAnalgesicos ?? "");
        setMedicacion(ed.medicacion);
        setAntihipertensivos(ed.antihipertensivos);
        setAntidiabeticos(ed.antidiabeticos);
        setEstatinas(ed.estatinas);
        setAnticoagulantes(ed.anticoagulantes);
        setTiroides(ed.tiroides);
        setDiuretico(ed.diuretico);
        setAnalgesicos(ed.analgesicos);
        setAntidepresivos(ed.antidepresivos);
        setAnsioliticos(ed.ansioliticos);
        setAntiosteoporoticos(ed.antiosteoporoticos);
        setInhalador(ed.inhalador);
        setProtectorEstomago(ed.protectorEstomago);
        setOtrosMedicacion(ed.otrosMedicacion);
        setVenredi(ed.venredi);
        setTerapiaOcupacional(ed.terapiaOcupacional);
        setTensionPAS(ed.tensionPAS ?? "");
        setTensionPAD(ed.tensionPAD ?? "");
        setTensionPMM(ed.tensionPMM ?? "");
        const actividadesFromApi = (ed.actividades ?? "")
          .split(",")
          .map((a) => a.trim())
          .filter(Boolean);
        const conocidas = actividadesFromApi.filter((a) => ACTIVIDADES_LIST.includes(a));
        const extras = actividadesFromApi.filter((a) => !ACTIVIDADES_LIST.includes(a));
        setActividades(createActividadesState(conocidas));
        setActividadesExtras(extras);
        setCaidasFinales(ed.caidasFinales ?? "");
        setNumPastillas(ed.numPastillas ?? "");
        setNumAnalgesicosFinal(ed.numAnalgesicosFinal ?? "");
        setCambioMedicacionFinal(!!ed.cambioMedicacionFinal);
        setConsultaMedico(!!ed.consultaMedico);
        setIngresosHospital(!!ed.ingresosHospital);
        setDatosInteresFinal(ed.datosInteresFinal ?? "");
      })
      .catch((err) => { console.error(err); setLoadError(true); });
  }, [paciente, idEntrevista]);

  return {
    loadError,
    codigo, setCodigo,
    createdAt, setCreatedAt,
    nombre, setNombre,
    apellidos, setApellidos,
    telefono, setTelefono,
    dateBirth, setDateBirth,
    numViven, setNumViven,
    numGrupo, setNumGrupo,
    numNivelEducacional, setNumNivelEducacional,
    numSexo, setNumSexo,
    codigoEntrevista, setCodigoEntrevista,
    tipoEntrevista, setTipoEntrevista,
    edad, setEdad,
    numFumador, setNumFumador,
    tiempoFumador, setTiempoFumador,
    aniosDeshabilitacion, setAniosDeshabilitacion,
    numAlcohol, setNumAlcohol,
    tiempoAlcohol, setTiempoAlcohol,
    aniosDeshabilitacionAlcohol, setAniosDeshabilitacionAlcohol,
    caidas12Meses, setCaidas12Meses,
    numCaidas, setNumCaidas,
    ayudaLocomocion, setAyudaLocomocion,
    protesisArticulares, setProtesisArticulares,
    protesisRodilla, setProtesisRodilla,
    protesisCadera, setProtesisCadera,
    protesisHombro, setProtesisHombro,
    protesisManoDedos, setProtesisManoDedos,
    protesisOtros, setProtesisOtros,
    vertigos, setVertigos,
    mareosAndar, setMareosAndar,
    cardiovascular, setCardiovascular,
    hipertension, setHipertension,
    insuficienciaCardiaca, setInsuficienciaCardiaca,
    accCerebrovascular, setAccCerebrovascular,
    anginaPecho, setAnginaPecho,
    infarto, setInfarto,
    trombosis, setTrombosis,
    otrosCardiovascular, setOtrosCardiovascular,
    respiratorio, setRespiratorio,
    asma, setAsma,
    epoc, setEpoc,
    otrosRespiratorio, setOtrosRespiratorio,
    genitoUrinario, setGenitoUrinario,
    infeccionUrinaria, setInfeccionUrinaria,
    calculosRenales, setCalculosRenales,
    insuficienciaRenal, setInsuficienciaRenal,
    incontinenciaUrinaria, setIncontinenciaUrinaria,
    prostata, setProstata,
    otrosGenitoUrinario, setOtrosGenitoUrinario,
    endocrino, setEndocrino,
    diabetes, setDiabetes,
    hipotiroidismo, setHipotiroidismo,
    hipercolesterolemia, setHipercolesterolemia,
    osteoporosis, setOsteoporosis,
    otrosEndocrino, setOtrosEndocrino,
    digestivo, setDigestivo,
    herniaHiato, setHerniaHiato,
    reflujo, setReflujo,
    pancreatitis, setPancreatitis,
    enfermedadHepatica, setEnfermedadHepatica,
    diverticulitis, setDiverticulitis,
    otrosDigestivo, setOtrosDigestivo,
    musculoEsqueletico, setMusculoEsqueletico,
    pieTobillo, setPieTobillo,
    rodilla, setRodilla,
    cadera, setCadera,
    lumbar, setLumbar,
    dorsal, setDorsal,
    cervical, setCervical,
    cabeza, setCabeza,
    hombro, setHombro,
    codo, setCodo,
    manoMunieca, setManoMunieca,
    nervioso, setNervioso,
    depresion, setDepresion,
    ansiedad, setAnsiedad,
    esclerosisMultiple, setEsclerosisMultiple,
    parkinson, setParkinson,
    alzheimer, setAlzheimer,
    deterioroCognitivo, setDeterioroCognitivo,
    neuropatiaPeriferica, setNeuropatiaPeriferica,
    otrosNervioso, setOtrosNervioso,
    sentidos, setSentidos,
    hipoacusia, setHipoacusia,
    tinitus, setTinitus,
    perdidaVision, setPerdidaVision,
    datosInteres, setDatosInteres,
    numAnalgesicos, setNumAnalgesicos,
    medicacion, setMedicacion,
    antihipertensivos, setAntihipertensivos,
    antidiabeticos, setAntidiabeticos,
    estatinas, setEstatinas,
    anticoagulantes, setAnticoagulantes,
    tiroides, setTiroides,
    diuretico, setDiuretico,
    analgesicos, setAnalgesicos,
    antidepresivos, setAntidepresivos,
    ansioliticos, setAnsioliticos,
    antiosteoporoticos, setAntiosteoporoticos,
    inhalador, setInhalador,
    protectorEstomago, setProtectorEstomago,
    otrosMedicacion, setOtrosMedicacion,
    venredi, setVenredi,
    terapiaOcupacional, setTerapiaOcupacional,
    tensionPAS, setTensionPAS,
    tensionPAD, setTensionPAD,
    tensionPMM, setTensionPMM,
    actividades, setActividades,
    actividadesExtras, setActividadesExtras,
    actividadesSeleccionadas,
    caidasFinales, setCaidasFinales,
    numPastillas, setNumPastillas,
    numAnalgesicosFinal, setNumAnalgesicosFinal,
    cambioMedicacionFinal, setCambioMedicacionFinal,
    consultaMedico, setConsultaMedico,
    ingresosHospital, setIngresosHospital,
    datosInteresFinal, setDatosInteresFinal,
  };
}
